"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertSelectedTableRowIds = exports.convertToSelectedTableRowIds = void 0;

// Return object with key(id) and value(true) pairs
// ["2"] => {"2": true}
var convertToSelectedTableRowIds = function convertToSelectedTableRowIds() {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return ids.reduce(function (accumulator, id) {
    accumulator[id] = true;
    return accumulator;
  }, {});
}; // Return array that only includes props with truthy values
// {"2": true} => ["2"]
// {"2": true, "3": false} => ["2"]


exports.convertToSelectedTableRowIds = convertToSelectedTableRowIds;

var convertSelectedTableRowIds = function convertSelectedTableRowIds() {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.keys(ids).filter(function (id) {
    return ids[id];
  });
};

exports.convertSelectedTableRowIds = convertSelectedTableRowIds;
//# sourceMappingURL=table.js.map